<template>
    <footer class="footer-wrapper">
        <div class="footer">
            <div class="left">
                <div class="phone">
                   <div class="icon">
                       <img src="../assets/icn-hotline.png" srcset="../assets/icn-hotline@2x.png 2x,../assets/icn-hotline@3x.png 3x">
                    </div>
                    <div class="hotline">
                        <p>
                            <span>客服热线 10:00-19:00</span>
                        </p>
                        <p>
                            010-53512690
                        </p>
                    </div> 
                </div>
                <div class="email">
                    <div class="icon">
                       <img src="../assets/icn-email.png" srcset="../assets/icn-email@2x.png 2x,../assets/icn-email@3x.png 3x">
                    </div>
                    <div class="service">
                        <p>
                            客服邮箱
                        </p>
                        <p>
                            <a href="mailto:service@sofund.com">service@sofund.com</a>
                        </p>
                    </div> 
                </div>
            </div>
            <div class="right">
                <div class="touch">
                    <span> <a href="mailto:service@sofund.com">联系我们 </a></span><span>| <a href="https://www.sofund.com" target="_blank">公司官网</a></span>
                </div>
                <div class="icp">
                    <span>人人智慧版权所有 </span><span> <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17007579号-1</a></span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style lang="scss">
.footer-wrapper{
    height: 127px;
    background-color: #00173d;
    .footer{
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        color: #fff;
        .left{
            display: flex;
            justify-content: space-around;
            margin-top:50px;
            .icon{
                width: 38px;
                height: 38px;
                object-fit: contain;
                vertical-align: middle;
            }
            .phone{
                display: flex;
                justify-content: space-around;
                .hotline{
                    vertical-align: middle;
                    p{
                        margin-left: 11px;
                    }
                    p:nth-child(1){
                        font-size:12px;
                        margin-bottom:5px
                    }
                    p:nth-child(2){
                        font-size:22px;
                    }
                }
            }
            .email{
                margin-left: 68px;
                display: flex;
                justify-content: space-around;
                .service{
                    vertical-align: middle;
                    p{
                        margin-left: 11px;
                    }
                    p:nth-child(1){
                        font-size:12px;
                        margin-bottom:5px
                    }
                    p:nth-child(2){
                        a{
                            color: #fff;
                        }
                        font-size:18px;
                    }
                }
            }
        }
        .right{
            margin-top: 73px;
            font-size: 12px;
            display: flex;
            justify-content: space-around;
            .icp{
                margin-left:15px
            }
            .touch{
                a{
                    color: #fff;
                }
            }
        }
    }
}
</style>